import { FsLeaderboard } from "db/model/leaderboard/FsLeaderboard";
import { Leaderboard } from "model/Leaderboard/Leaderboard";

export const mapLeaderboard = (
  fsModel: FsLeaderboard,
  id: string
): Leaderboard => {
  return {
    id,
    lastUpdated: fsModel.lastUpdated,
    count: fsModel.count,
    users: {},
    missingSorts: [],
  };
};
